/**
 * @type Controller
 * @name PrintRundownCtrl
 * @packageName print_rundown_ctrl.js
 *
 * @description
 *
 * The `PrintRundownCtrl` interaction delete mdDialog for rundown
 *
 */
class PrintRundownCtrl {

    constructor ($scope, $mdDialog, $http, $timeout, locals) {

        //Attach dependicies to class root
        this.$mdDialog = $mdDialog
        this.$http = $http
        this.$timeout = $timeout
        this.selectedTemplate = locals.templateId

        this.$scope = $scope

        //Ugly work around CANCEL button!
        $scope.cancel = () => {
            this.cancelButton()
        }

        //Ugly work around OK button!
        $scope.ok = () => {
            this.ok()
        }

        // this.$scope.getAvailableDates = (id) => {
        //     this.getAvailableDates(id);
        // };

        $scope.clickProgram = (id) => {
            this.clickProgram(id)
        }

        $scope.print = () => {
            this.print()
        }

        this.currentId = ''

        $scope.selectedItem = { title: 'select your program' }
        $scope.selectedDate = { value: new Date() }
        $scope.items = []
        this.rundownInfo = this.$scope.rundownInfo
        this.availableDates = []
        this.dateFilterUpdate = {}
        this.cachedMonths = []
        this.number = true
        this.loaded = false

        $scope.checkWhichDateIsAvailable = (date) => {
            if (this.availableDates.indexOf(moment(date).format('YYYY-MM-DD')) > -1) {
                return true
            }
            return false
        }

        $scope.availableBroadcastDates = (data) => {
            let date = data.dateUtil.incrementMonths(data.calendarCtrl.firstRenderableDate, data.offset)
            let httpDate = new Date(date)
            let year = httpDate.getFullYear()
            let month = parseInt(httpDate.getMonth(), 10)
            if (this.currentId == '') {
            } else {
                this.getAvailableDates(this.currentId, year, month)
            }
        }

        this.getPrograms()
    }

    getPrograms () {
        this.$http.get('/programs/all')
            .then(response => {
                const data = response.data
                data.map(item => {
                    this.$scope.items.push(item)
                })
            })
    }

    clickProgram (id) {
        this.loaded = false
        this.getAvailableDates(id)
        setTimeout(() => {
            this.$timeout(() => {
                this.$scope.hideDate = true
                this.$scope.$apply()
                this.$timeout(() => {
                    this.$scope.hideDate = false
                    this.$scope.$apply()
                })
            })
        }, 1000)
    }

    getAvailableDates (id, year = moment().year(), month = moment().month()) {

        if (id !== this.currentId) {
            this.availableDates = []
            this.cachedMonths = []
            this.currentId = id
        }

        this.year = year
        this.month = month

        if (this.loaded == false) {
            let year = this.year
            let month = this.month
            for (let j = 0; j < 3; j++) {
                month = month - 1
                if (month < 0) {
                    month = 11
                    year--
                }
            }
            for (let i = 0; i < 8; i++) {
                this.loaded = true
                this.getAvailableDates(id, year, month)
                month++
                if (month > 11) {
                    month = 0
                    year++
                }
            }
        }
        if (this.cachedMonths.indexOf(year + '/' + month) > -1) {
        } else {
            this.cachedMonths.push(year + '/' + month)
            this.$http.get(`broadcasts/related/${id}/${year}/${month}`).then(response => {
                const data = response.data
                data.map(calendarItem => {
                    this.availableDates.push(moment(calendarItem.start).format('YYYY-MM-DD'))
                })
            })
        }
    }

    /*
     * managed CANCEL event from confirm dailog
     */
    cancelButton () {
        this.$mdDialog.cancel()
    }

    print () {
        let value = moment(this.$scope.selectedDate.value, 'YYYY-MM-DD hh:mm:ss a').format()
        //Open the printpage in a new tab using an anchor with rel='noopener'
        //Else the new tab will use the same renderer as the original page and window.print() will freeze the rundown
        //This seems to be the only workaround for this, source:
        //https://bugs.chromium.org/p/chromium/issues/detail?id=178931

        let anchor = window.document.createElement('a')
        let csrf = window.document.querySelector('meta[name=\'csrf-token\']').getAttribute('content')

        anchor.href = `print/broadcastitemstemplate/${this.$scope.selectedItem.id}/${value}/${this.selectedTemplate}?_token=${csrf}`
        anchor.target = '_blank'
        anchor.rel = 'noopener'
        anchor.click()
    }

    /*
     * managed OK event from confirm dailog
     */
    ok () {
        this.$mdDialog.hide()
    }
}

/*
 * Inject dependicies
 */
PrintRundownCtrl.$inject = ['$scope', '$mdDialog', '$http', '$timeout', 'locals']

/*
 * Browsify connection: execute controller
 */
module.exports = PrintRundownCtrl
